import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { ModelActionsModal } from '@models-global/model-actions';
import * as actions from '@module-claims/store/pharmacy.actions';
import { ContractPharmacyLinkParams } from '@module-claims/models/pharmacy.interface';

export interface IContractPharmacyModalState {
  readonly action?: ModelActionsModal;
  readonly data?: ContractPharmacyLinkParams;
}

@State<IContractPharmacyModalState>({
  name: 'ContractPharmacyModalStateState',
  defaults: {
    action: undefined,
    data: undefined
  }
})
@Injectable()
export class ContractPharmacyModalState {
  @Action(actions.ContractPharmacyModalSave)
  saveModal(
    ctx: StateContext<IContractPharmacyModalState>,
    { params }: actions.ContractPharmacyModalSave
  ): void {
    ctx.patchState({
      action: 'save',
      data: params
    });
  }

  @Action(actions.ContractPharmacyModalClose)
  closeModal(ctx: StateContext<IContractPharmacyModalState>): void {
    ctx.patchState({
      action: 'close',
      data: undefined
    });
  }
}
